import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_vi.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.vi.js'
import 'moment/locale/vi.js'
import './translations.tc.vi.js'

$.fn.datepicker.defaults.language = 'vi'

I18n.defaultLocale = 'vi'
I18n.locale = 'vi'

export default App
